namespace $ {
	$hyoo_crus_yard.masters = [ ... new Set([ $mol_dom_context.location.origin + '/', ... $hyoo_crus_yard.masters ]) ]
}
